import React, { useEffect, useState, useContext } from "react";
import "moment/locale/th";
import { useNavigate } from "react-router";
import * as adminApi from "../../../../service/adminApi";
import { CurrentUserContext } from "../../../../App";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import { RedirectCode400 } from "../../../RedirectCode400";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import format from "date-fns/format";
import TableSearchV1 from "../../../tableV1/tableSearchV1";

function LaboratoryInspectionGuideline() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [guidelineList, setGuidelineList] = useState([]);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalGuideline, setTotalGuideline] = useState(null);
  const [sortBy, setSortBy] = useState({ id: "", desc: false });

  const [filters, setFilters] = useState({
    title: "",
    "create_date.date": "",
    "updated_date.date": "",
  });

  useEffect(() => {
    fetchGuidelines();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [page, filters, sortBy]);

  const fetchGuidelines = async () => {
    setLoading(true);
    let res = await adminApi.getGuideline(
      page,
      10,
      filters.title,
      formatDate(filters["create_date.date"]),
      formatDate(filters["updated_date.date"]),
      sortBy.id,
      sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
    );
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setGuidelineList(res["data"]["guideline_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
        setTotalGuideline(res["data"]["amount"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "หัวข้อ",
      accessor: "title",
      Cell: ({ row }) => {
        const title = row.original.title;
        return (
          <div
            className="truncate w-full max-w-[800px] max-h-[100px]"
            title={title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        );
      },
      Filter: "text",
    },
    {
      Header: "วันที่แจ้ง",
      accessor: "create_date.date",
      Cell: ({ row }) => {
        const createdDate =
          row.original.create_date && row.original.create_date.date
            ? row.original.create_date.date
            : null;
        return createdDate ? formatDateThai(createdDate) : "-";
      },
      Filter: "date",
    },
    {
      Header: "วันที่แก้ไข",
      accessor: "updated_date.date",
      Cell: ({ row }) => {
        const updatedDate =
          row.original.updated_date && row.original.updated_date.date
            ? row.original.updated_date.date
            : null;
        return updatedDate ? formatDateThai(updatedDate) : "-";
      },
      Filter: "date",
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "actions",
      Cell: ({ row }) => {
        const i = row.original;

        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#DFEEFA 0% 0% no-repeat padding-box" }}
              onClick={() =>
                navigate(
                  `/admin/management/laboratory-inspection-guideline/view-laboratory/${i["guideline_id"]}`,
                  {
                    state: {
                      type: "guideline",
                      id: i["guideline_id"],
                      title: i["title"],
                      detail: i["detail"],
                      fname: i["owner"]["fname"],
                      lname: i["owner"]["lname"],
                      pined: i["pin"],
                      active: i["active"],
                      create_date: i["create_date"]?.["date"] || null,
                      update_date: i["updated_date"]?.["date"] || null,
                    },
                  },
                )
              }
            >
              <FaEye className="text-[#46A8F4] h-[14px]" />
            </div>
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#AFEBE3 0% 0% no-repeat padding-box" }}
              onClick={() =>
                navigate(
                  "/admin/management/laboratory-inspection-guideline/edit-laboratory",
                  {
                    state: {
                      type: "guideline",
                      id: i["guideline_id"],
                      title: i["title"],
                      detail: i["detail"],
                      pined: i["pin"],
                      active: i["active"],
                      publishStartDate: i["publish_start_date"],
                      publishEndDate: i["publish_end_date"],
                    },
                  },
                )
              }
            >
              <FaEdit className="text-[#00917E] h-[14px]" />
            </div>
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
              onClick={() => removeGuideline(i)}
            >
              <FaTrash className="text-[#D32736] h-[14px]" />
            </div>
          </div>
        );
      },
    },
  ];

  const removeGuideline = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item["title"]} ใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await adminApi.removeGuideline(item["guideline_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        fetchGuidelines();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setGuidelineList([]);
    }
  };

  return (
    <div className="min-w-[708px] overflow-x-auto">
      <div className="mt-[60px]"></div>
      <div>
        <PageHeaderV2 titlename={"แนวทางการตรวจ"} />
        <TableSearchV1
          columns={columns}
          data={guidelineList}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          total={totalGuideline}
          page={page}
          maxPage={maxPage}
          setPage={setPage}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          addData={{
            name: "เพิ่มเเนวทางการตรวจ",
            url: "/admin/management/laboratory-inspection-guideline/add-laboratory",
            type: "guideline",
          }}
          noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
        />
      </div>
    </div>
  );
}

export default LaboratoryInspectionGuideline;
